// TODO 0622 오픈 버전에서 버튼 주석 처리, 추 후 오픈 예정

// import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { type VideoInfo } from '~/features/home/apis/mainInfo'
import Dots from '~/shared/assets/graphics/Dots'
import Lines from '~/shared/assets/graphics/Lines'
import Plus from '~/shared/assets/graphics/Plus'
// import Button from '~/shared/components/buttons/Button'
import theme from '~/shared/styles/theme'

interface Props {
  eventInfo: VideoInfo
}

function EventInfo({ eventInfo }: Props) {
  // const navigate = useNavigate()

  return (
    <Wrapper>
      <LeftPlusGraphic color="#FDE1A5" />
      <RightPlusGraphic color="#FDE1A5" />
      <DotsGraphic color="#C6E6E8" />
      <LinesGraphic />
      <ContentBox>
        <IllustarfesVideo
          loop
          autoPlay
          muted
          playsInline
          src={eventInfo.contentsObj.url}
        ></IllustarfesVideo>
        <Title>{eventInfo.title}</Title>
        <Desc>{eventInfo.desc}</Desc>

        <ButtonBox>
          {/* <InfoButton
            $width={148}
            $height={58}
            $fontSize={24}
            $variant="primary"
            onClick={() => navigate(`${eventInfo.link}`)}
          >
            자세히 보기
          </InfoButton> */}
          {/* {viewport < theme.deviceSizes.medium ? (
            <PlayVideoButton
              width={132}
              height={48}
              fontSize={24}
              $variant="black"
            >
              비디오 보기
            </PlayVideoButton>
          ) : null} */}
        </ButtonBox>
      </ContentBox>
    </Wrapper>
  )
}

export default EventInfo

const Wrapper = styled.div`
  position: relative;

  display: flex;

  aspect-ratio: 1920/1080;
  width: 100vw;
  max-width: 1920px;
  margin: 0 auto;

  @media ${theme.device.medium} {
    height: 100vh;
  }
`

const LeftPlusGraphic = styled(Plus)`
  position: absolute;
  top: 30%;
  left: 20%;
`

const RightPlusGraphic = styled(Plus)`
  position: absolute;
  top: 70%;
  right: 20%;
  object-fit: cover;
`

const DotsGraphic = styled(Dots)`
  position: absolute;
  top: 70%;
  left: 10%;

  width: 432px;
  height: auto;

  object-fit: cover;

  @media ${theme.device.medium} {
    top: 70%;
    left: -30%;
    width: 284px;
    height: 127px;
  }
`

const LinesGraphic = styled(Lines)`
  position: absolute;
  top: 15%;
  right: 10%;
  object-fit: cover;

  @media ${theme.device.medium} {
    top: 0%;
    right: -5%;
    width: 260px;
    height: 188px;
  }
`

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
`

const IllustarfesVideo = styled.video`
  position: absolute;

  /* z-index: ${theme.zIndex.belowDefault}; */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 80%;
  height: auto;

  border-radius: 465px;

  @media ${theme.device.medium} {
    width: 90%;
    height: 80vh;
    object-fit: cover;
  }
`

const Title = styled.h1`
  z-index: ${theme.zIndex.aboveDefault};

  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 32px;
  line-height: 84px;
  color: ${theme.colors.white};

  @media ${theme.device.medium} {
    width: 60%;

    font-size: 24px;
    font-weight: 700;
    line-height: 140%;
    text-align: center;
  }
`

const Desc = styled.h4`
  z-index: ${theme.zIndex.aboveDefault};

  font-family: NanumSquareNeo-Heavy, sans-serif;
  font-size: 72px;
  font-weight: 500;
  line-height: 84px;
  color: ${theme.colors.white};

  @media ${theme.device.medium} {
    font-size: 32px;
  }
`

const ButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin: 30px 0;
`

// const InfoButton = styled(Button)`
//   width: 171px;
//   height: 58px;

//   font-family: NanumSquareNeo-Bold, sans-serif;
//   font-size: 20px;
//   color: ${theme.colors.grey_5};

//   background-color: ${theme.colors.mint_3};
// `

// const PlayVideoButton = styled(Button)`
//   width: 171px;
//   height: 58px;
//   font-size: 20px;
// `
